var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbk24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32992 1.33028C5.73829 1.6257 5.29754 2.13396 5.08925 2.76142L1.12826 14.6658C0.918378 15.2913 0.967482 15.9645 1.26527 16.5587C1.56128 17.1461 2.06995 17.5881 2.69523 17.7971L15.685 22.1583C16.3149 22.3674 16.9873 22.3197 17.5781 22.0231C18.1695 21.7243 18.6113 21.2188 18.817 20.5895L22.7798 8.68875C23.2136 7.39244 22.5081 5.98585 21.2118 5.55401L8.22319 1.19406C7.59217 0.985957 6.92411 1.0313 6.32992 1.33028Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57324 15.1459H7.4684V8.96196H6.57324V15.1459ZM12.6792 12.763C11.9737 13.5502 11.094 14.1854 10.0743 14.5792L9.48803 14.8063V9.29082L10.0672 9.51516C11.0883 9.90502 11.9702 10.5404 12.6792 11.3239C13.1839 10.5117 13.4973 9.56941 13.5617 8.54456C13.7221 5.90047 12.066 3.47418 9.79116 2.62971L7.91452 2.00522C7.06767 1.72307 6.16618 2.19015 5.8868 3.03462L1.91453 14.9457C1.63238 15.7935 2.10758 16.7132 2.95541 16.992L11.9702 20.0018C12.8893 19.0245 13.4854 17.7296 13.5726 16.2852C13.6522 14.9964 13.3162 13.7813 12.6792 12.763Z",
    fill: "#198FCA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1595 12.0437C11.6562 11.4537 11.0477 10.9579 10.3452 10.5947V13.5014C11.0477 13.1374 11.6595 12.6357 12.1595 12.0437Z",
    fill: "#E95705"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7317 15.1264L17.6141 15.1296L15.3152 12.037L17.6504 8.94543L18.7776 8.94108L16.437 12.0416L18.7317 15.1264ZM20.9232 6.34866L12.6504 3.58398C13.7616 4.8003 14.4415 6.41637 14.4447 8.1863C14.4464 9.58536 14.0103 10.9236 13.2511 12.0437C14.013 13.1605 14.4518 14.4977 14.4556 15.8968C14.4562 17.5679 13.8556 19.1076 12.8557 20.2997L15.9625 21.3367C16.8122 21.6192 17.7091 21.1521 17.9916 20.3051L21.9659 8.39519C22.2473 7.54874 21.7717 6.62982 20.9232 6.34866Z",
    fill: "#015198"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbk24);
export default __webpack_public_path__ + "static/media/IBK투자증권-24.854c9f9e7f762deebc6ee7c8509f6a76.svg";
export { ForwardRef as ReactComponent };